module.exports = __webpack_public_path__ + "img/p.5862d06a.png";